'use client';

// export default Icon;
import React from 'react';
import dynamicIconImport from '@/app/_libs/utils/dynamicImportSvg';

const Icon = ({ name, ...props }) => {
  const IconComponent = dynamicIconImport(name);

  // Render the icon with dynamic import
  return <IconComponent {...props} />;
};

export default Icon;
